import { Component, inject, ViewChild } from '@angular/core';
import { addCategoryRequest } from '../../models/Categories Requests DTO/add-category-request.model';
import { CategoryService } from '../../Services/category.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../Services/notification.service';
import { UploadImageComponent } from '../../adminComponents/upload-image/upload-image.component';

@Component({
  selector: 'app-page-add-category',
  templateUrl: './page-add-category.component.html',
  styleUrls: ['./page-add-category.component.scss'],
})
export class PageAddCategoryComponent {
  @ViewChild(UploadImageComponent) uploadImageComponent!: UploadImageComponent;

  model: addCategoryRequest;
  router = inject(Router);
  notificationService = inject(NotificationService);
  constructor(private categoryService: CategoryService) {
    this.model = {
      nameAr: '',
      nameEn: '',
      nameTr: '',
      CategoryImage: null,
    };
  }

  onFormSubmit() {
    if (
      this.model.CategoryImage != null &&
      this.model.nameTr != '' &&
      this.model.nameEn != '' &&
      this.model.nameTr != ''
    ){
      this.categoryService.addCategory(this.model).subscribe({
        next: (response) => {
          //console.log('Category added successfully:', response);
          this.showSuccessMessage();
          this.clearModel();
          this.uploadImageComponent.resetImage();
        },
        error: (err) => {
          this.showErrorMessage();
          //console.error("Error occurred while adding category:", err);
          if (err.error) {
            //console.error("Error details:", err.error);
          }
        },
      });
    //console.log('Form submitted:', this.model);
    }

    else{
      this.MessageRequiredField();

    }
      
  }

  onSelectedImage(img: File) {
    this.model.CategoryImage = img;
    //console.log("Selected image:", this.model.CategoryImage);
  }
  showSuccessMessage() {
    this.notificationService.showMessage(
      'Successfully Added Category',
      'success'
    );
  }

  MessageRequiredField() {
    this.notificationService.showMessage('Required Field is Empty', 'danger');
  }

  showErrorMessage() {
    this.notificationService.showMessage('Failed To Add Category', 'danger');
  }

  ErrorMessage() {
    this.notificationService.showMessage('Failed Loading Data', 'danger');
  }

  clearModel() {
    this.model = {
      nameAr: '',
      nameEn: '',
      nameTr: '',
      CategoryImage: null,
    };
  }
}
